export default __webpack_public_path__ + "static/media/insalataTtsIt_It60.06488d45.mp3";